import React from 'react'
import ExperienceDetailsHeaderPresentation from '../../presentation/experience.details.presentation/ExperienceDetailsHeaderPresentation'
import { type ExperienceType } from '../../../experiencetype/types/types'
interface ExperienceDetailsHeaderContainerProps {
  onSelectHandler: (exptype: Partial<ExperienceType> | null) => void
  experienceType?: Partial<ExperienceType> | null
}
const ExperienceDetailsHeaderContainer: React.FC<
ExperienceDetailsHeaderContainerProps
> = ({ onSelectHandler, experienceType }) => {
  return (
    <ExperienceDetailsHeaderPresentation
      onSelectHandler={onSelectHandler}
      experienceType={experienceType}
    />
  )
}

export default ExperienceDetailsHeaderContainer
